import { InventoryBySerialNumberStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const InventoryBySerialNumberStatus = {
  OnHand: {
    value: InventoryBySerialNumberStatusEnum.OnHand,
    description: 'The serial number is active, valid and on-hand',
    sort: 0,
    tone: StatusToneEnum.Active,
  },
  Sold: {
    value: InventoryBySerialNumberStatusEnum.Sold,
    description: 'The serial number is sold',
    sort: 1,
    color: 'var(--status-custom-amber)',
  },
  Consumed: {
    value: InventoryBySerialNumberStatusEnum.Consumed,
    description: 'The serial number is consumed in production',
    sort: 2,
    color: 'var(--status-custom-cyan)',
  },
  InActive: {
    value: InventoryBySerialNumberStatusEnum.InActive,
    description: 'The serial number is in active',
    sort: 3,
    tone: StatusToneEnum.Inactive,
  },

  Expired: {
    value: InventoryBySerialNumberStatusEnum.Expired,
    description: 'The serial number is expired',
    sort: 4,
    tone: StatusToneEnum.Failure,
  },
}
